export default class GridItemResizer {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.setGridResizer();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Caches grids in state
  //===========================================================================

  setState() {
    this.state = {
      $grids: $('.js-resizable-grid')
    };
  }

  //===========================================================================
  // Sets grid sizes on page load and ajax loads
  //===========================================================================

  setGridResizer() {
    this.setState();
    this.resizeGrids();
  }

  //===========================================================================
  // Resizes all grids
  //===========================================================================

  resizeGrids() {
    this.state.$grids.each((i, grid) => {
      let $grid = $(grid);
      this.resizeGridItems($grid);
    });
  }

  //===========================================================================
  // Resizes grid item heights so that the buttons align
  //===========================================================================

  resizeGridItems($grid) {
    const $inner  = $grid.find('.js-resizable-item');
    const $outer  = $grid.find('.js-resizable-item-wrapper');
    const heights = $inner.map(function (i, item) {
      return item.offsetHeight;
    });
    const max = Math.max.apply(Math, heights);
    const minHeight = window.innerWidth > 400 ? `${ max }px` : 'auto';

    if ($inner.length && minHeight) {
      $outer.css({
        'minHeight': minHeight
      });
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(window).on('resize', this.resizeGrids.bind(this));
    $(document).on('resetGrids', this.setGridResizer.bind(this));
    $(document).on('historyChange', this.setGridResizer.bind(this));
  }
}
